import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { TableActionButtons, TableAction } from "./TableActionComponent.styled";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";

const TableActionComponent = ({ showCards, setShowCards }) => {
  return (
    <TableAction>
      <Tooltip title="View List">
        <TableActionButtons
          iconColor={showCards}
          onClick={() => setShowCards(false)}
          className="MuiButtonBase-root MuiIconButton-root"
        >
          <span
            style={{ width: "fit-content" }}
            className="MuiIconButton-label"
          >
            <ViewList className="list-view" />
          </span>
        </TableActionButtons>
      </Tooltip>
      <Tooltip title="View Cards">
        <TableActionButtons
          iconColor={showCards}
          onClick={() => setShowCards(true)}
          style={{ borderLeft: "none" }}
          className="MuiButtonBase-root MuiIconButton-root"
        >
          <span
            style={{ width: "fit-content" }}
            className="MuiIconButton-label"
          >
            <ViewCards className="card-view" />
          </span>
        </TableActionButtons>
      </Tooltip>
    </TableAction>
  );
};

export default TableActionComponent;
